import React from 'react'

let isRefreshing = false
let refreshPromise: Promise<string | null> | null = null

const getNewAccessToken = async (
  setLoginStatus: React.Dispatch<React.SetStateAction<boolean>>,
): Promise<string | null> => {
  if (isRefreshing) return refreshPromise // Return ongoing refresh promise

  isRefreshing = true
  // eslint-disable-next-line
  refreshPromise = new Promise(async resolve => {
    try {
      const requestOptions = {
        method: 'GET',
        // eslint-disable-next-line no-undef
        credentials: 'include' as RequestCredentials,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('refreshToken')}`,
        },
      }

      const tokenResp = await fetch(`${process.env.REACT_APP_BASE_URL}/token`, requestOptions)

      if (!tokenResp.ok) {
        throw new Error('Token refresh failed')
      }

      const tokenData = await tokenResp.json()
      if (tokenData.accessToken) {
        localStorage.setItem('accessToken', tokenData.accessToken)
        resolve(tokenData.accessToken)
      } else {
        setLoginStatus(false)
        resolve(null)
      }
    } catch (error) {
      setLoginStatus(false)
      resolve(null)
    } finally {
      isRefreshing = false
      refreshPromise = null
    }
  })

  return refreshPromise
}

const applyFetchInterceptor = (setLoginStatus: React.Dispatch<React.SetStateAction<boolean>>): void => {
  const { fetch: originalFetch } = window

  window.fetch = async (...args): Promise<Response> => {
    const [resource, config] = args

    const response = await originalFetch(resource, config)

    if (response.status === 401) {
      const newAccessToken = await getNewAccessToken(setLoginStatus)

      if (!newAccessToken) {
        return response // Prevent infinite loop if refresh fails
      }

      // Retry the original request with the new token
      return originalFetch(resource, {
        ...config,
        headers: {
          ...config?.headers,
          Authorization: `Bearer ${newAccessToken}`,
        },
      })
    }

    return response
  }
}

export default applyFetchInterceptor
